<template>
  <v-layout>
    <v-app-bar color="white">
      <div class="header">
        <div class="logoSpace">
          <img
            src="./assets/logo.jpg"
            alt="山梨県ロゴ"
            class="logo"
            @click="this.$router.push('/')"
          />
        </div>
        <div class="logoutSpace">
          <div class="account">
            <v-icon icon="mdi-account-circle"></v-icon>
            <span>{{ username }}</span>
            <v-chip> {{ authority }} </v-chip>
          </div>
          <v-btn @click="keycloak.logout()" class="bg-blue-lighten-1"
            >logout</v-btn
          >
        </div>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      color="grey-lighten-3"
      expand-on-hover
      rail
      width="400"
    >
      <div class="navigation">
        <v-list density="compact" nav>
          <v-list-item
            prepend-icon="mdi-folder"
            title="データ登録状況"
            value="data"
            @click="this.$router.push('/data')"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-translate-variant"
            title="翻訳テーブルの確認"
            value="translate"
            @click="this.$router.push('/translate')"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-folder-plus-outline"
            title="翻訳アイテムの作成"
            value="translateItemCreate"
            @click="this.$router.push('/translate/item-create')"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-account-multiple"
            title="Keycloakユーザ登録用JSONファイルの作成"
            value="keycloak"
            @click="this.$router.push('/keycloak')"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-wrench-clock"
            title="メンテナンス情報の登録・更新"
            value="maintenance"
            @click="this.$router.push('/maintenance')"
            v-if="authorityDistribution"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-backup-restore"
            title="カタログサイトのファイル復元"
            value="resourceRecovery"
            @click="this.$router.push('/resource-recovery')"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-link-box-variant"
            title="各システムリンク"
            value="linkCollection"
            @click="this.$router.push('/linkCollection')"
          ></v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-layout>
</template>

<script>
export default {
  name: "App",
  props: ["keycloak"],
  mounted() {
    console.log(this.keycloak);
    this.$store.commit("setToken", this.keycloak.token);
    this.$store.commit(
      "setUsername",
      this.keycloak.idTokenParsed.preferred_username
    );
    if (this.keycloak.tokenParsed.scope.includes("DELETE./translate-table")) {
      this.$store.commit("setAuthority", true);
    }
    setInterval(() => {
      this.$store.commit("setToken", this.keycloak.token);
    }, 60000);
  },
  computed: {
    authority() {
      if (this.keycloak.tokenParsed.scope.includes("DELETE./translate-table")) {
        return "管理者";
      } else {
        return "ユーザー";
      }
    },
    username() {
      return this.$store.getters.username;
    },
    token() {
      return this.$store.getters.token;
    },
    authorityDistribution() {
      return this.$store.getters.authority;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap");
* {
  font-family: "Noto Sans JP", sans-serif;
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logoSpace {
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logoutSpace {
  width: auto;
  display: flex;
  align-items: center;
  column-gap: 1vw;
  padding: 1vw;
}

.account {
  display: flex;
  column-gap: 0.2vw;
  align-items: center;
}

.logo {
  max-width:50px;
  cursor: pointer;
}

.navigation {
  padding-top: 20px;
}
</style>
